import { Beneficiary } from "../../../../types/beneficiaries";
import { customToast } from "../../../Common/Toast";
import { validateAllBeneficiaries } from "../utils/beneficiaryUtils";

interface UseBeneficiaryValidationReturn {
  validateAndProcessBeneficiaries: (
    beneficiaries: Beneficiary[],
    error: string | null,
    processCallback: (beneficiaries: Beneficiary[]) => Promise<boolean>,
  ) => Promise<void>;
}

export const useBeneficiaryValidation = (): UseBeneficiaryValidationReturn => {
  const validateAndProcessBeneficiaries = async (
    beneficiaries: Beneficiary[],
    error: string | null,
    processCallback: (beneficiaries: Beneficiary[]) => Promise<boolean>,
  ) => {
    try {
      if (error) {
        customToast("Error: Unable to continue", "error");
        return;
      }

      if (!validateAllBeneficiaries(beneficiaries)) {
        customToast(
          "Please fill out all fields for each beneficiary.",
          "error",
        );
        return;
      }

      await processCallback(beneficiaries);
    } catch {
      customToast("An error occurred while processing beneficiaries.", "error");
    }
  };

  return {
    validateAndProcessBeneficiaries,
  };
};
